import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
  href?: string;
}
export function CTAButton({
  text = 'QUIERO MONETIZAR EN 15 DÍAS',
  onClick,
  className = '',
  fullWidth = false,
  showIcon = true,
  size = 'lg',
  href = 'https://buy.stripe.com/9B68wP5P78JIapcbUPefC09'
}: CTAButtonProps) {
  const sizeClasses = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg md:text-xl'
  };
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        relative group overflow-hidden rounded-full font-bold uppercase tracking-wider text-white cursor-pointer
        bg-gradient-to-r from-cyan-500 to-purple-600
        shadow-[0_0_20px_rgba(0,212,255,0.3)]
        hover:shadow-[0_0_30px_rgba(0,212,255,0.5)]
        transition-all duration-300 inline-flex
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full justify-center' : 'w-auto'}
        ${className}
      `} onClick={onClick} data-id="element-29">
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-10" data-id="element-30" />

      <span className="relative z-20 flex items-center justify-center gap-2" data-id="element-31">
        {text}
        {showIcon && <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-32" />}
      </span>

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full animate-ping bg-cyan-400/20 opacity-0 group-hover:opacity-100 duration-1000" data-id="element-33" />
    </motion.a>;
}